import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://f9c3bbc5a3e9b655052d96cec6716067@o4504549415911424.ingest.us.sentry.io/4508523304779776",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});